module.exports = __webpack_public_path__ + "static/img/about.1b1e1f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about.png
// module id = ywBa
// module chunks = 1